import { API } from "../apis/APIsConfig";
import Constants from "../utils/constants";

export function recoverPass(cedula: string, ip: string) {
  return API.post(Constants.APIURLS.RECOVERPASS, {
    cedula: cedula,
    direccionIP: ip,
  });
}

export function changePass(currentPass, newPass) {
  return API.post(Constants.APIURLS.CHANGEPASS, {
    contasenaActual: currentPass,
    nuevaContasena: newPass,
  });
}

export function validarAfiliado(cedula) {
  return API.get(Constants.APIURLS.VALIDATEAFILIADO + cedula);
}

export function getPreguntasSeguridad(cedula) {
  return API.get(Constants.APIURLS.PREGUNTASSEGURIDAD + cedula);
}

export function getPreguntasSeguridadSMS(cedula) {
  return API.get(Constants.APIURLS.PREGUNTASSEGURIDAD + cedula);
}

export function validarRespuestas(cedula: string, respuestas: any[]) {
  return API.post(Constants.APIURLS.VALIDARPREGUNTASSEGURIDAD, {
    cedula: cedula,
    respuestas: respuestas,
  });
}

export function getResumenRespuestas(cedula: string, respuestas: any[]) {
  return API.post(Constants.APIURLS.RESUMENRESPUESTAS, {
    cedula: cedula,
    fechaCorte: new Date(),
    respuestas: respuestas,
  });
}

export function getResumenCuentaCedula(cedula: string) {
  return API.post(Constants.APIURLS.RESUMENCUENTACEDULA, {
    cedula: cedula,
    fechaCorte: new Date()
  });
}

export function validateGuidPass(guid: string) {
  return API.get(Constants.APIURLS.VALIDATETOKENPASS + guid);
}

export function resetPass(newPass: string, guid: string) {
  return API.post(Constants.APIURLS.RESETPASS, { clave: newPass, guid: guid });
}

export function isAffiliate(cedula) {
  return API.get(Constants.APIURLS.ISAFILIADO + cedula);
}

export function solicitudAfiliacion(newAfiliate: any) {
  return API.post(Constants.APIURLS.SOLICITUDAFILIACION, newAfiliate);
}